import { Alert, Empty, message, Spin } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import PlanEmpresa from "../../../PanelPrincipal/MiPlanBiwo/PlanEmpresa";

class ComplementosPlan extends Component {
    state = { loading: true, plan: null, version: 0 };

    componentDidMount() {
        this.consultar();
    }

    consultar = () => {
        this.setState({ loading: true });
        axios.post("miPlanBiwo/selectMiPlan", {}, { headers: this.props.headersToken }).then((res) => {
            if (res.data.success === 2) this.setState((s) => ({ loading: false, plan: res.data.data, version: s.version + 1 }));
            else {
                this.setState({ loading: false });
                message.error(res.data.message || "No se pudieron consultar los complementos");
            }
        });
    };

    enviar = (ruta, body) => {
        this.setState({ loading: true });
        axios.post("miPlanBiwo/" + ruta, body, { headers: this.props.headersToken }).then((res) => {
            if (res.data.success === 2) {
                message.success(res.data.message);
                this.consultar();
                if (this.props.onCambio) this.props.onCambio();
            } else {
                this.setState({ loading: false });
                message.error(res.data.message || "No se pudo actualizar");
            }
        });
    };

    cambiarModulo = (clave, valor) => this.enviar("guardarModulosLibres", { empresaId: this.props.empresaId, modulos: { [clave]: valor } });

    render() {
        const { plan, loading, version } = this.state;
        const empresa = plan?.empresas.find((e) => String(e._id) === String(this.props.empresaId));
        return (
            <Spin spinning={loading}>
                {!empresa ? (
                    <Empty description={loading ? "Cargando..." : "No se encontró información de esta empresa"} />
                ) : (
                    <>
                        <Alert
                            type="info"
                            showIcon
                            style={{ marginBottom: 12, borderRadius: 6 }}
                            message={
                                plan.cobroActivo
                                    ? "Para bajar de paquete o dar de baja un módulo, pídelo a BIWO. Las opciones de cada módulo están en Preferencias del sistema."
                                    : "Al cambiar un módulo, vuelve a seleccionar la empresa para ver el menú. Las opciones de cada módulo están en Preferencias del sistema."
                            }
                        />
                        <PlanEmpresa key={`${empresa._id}-${version}`} empresa={empresa} plan={plan} onEnviar={this.enviar} onCambiarModulo={this.cambiarModulo} />
                    </>
                )}
            </Spin>
        );
    }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken, empresaId: state.empresa.id });

export default connect(mapStateToProps)(ComplementosPlan);
